import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Observacion.types';
import { IObservacion } from './Observacion.lib';

export class Observacion extends IObservacion
{

    public static async create( id: number ): Promise<Observacion>
    {
        let o = new Observacion();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/pedidos/observaciones';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Observacion>; Error?: boolean; }>
    {

        let a: Array<Observacion> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest(  );

        if ( params.pedido )
            request.path = `/pedidos/${params?.pedido}/observaciones`;
        else
        {
            request.path = `/pedidos/observaciones`;
            request.params = params;
        }

        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Observacion( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save( EnviarAPlataforma: boolean = false ): Promise<boolean>
    {
        try
        {
            let req = new apiRequest( `/pedidos/${this.Pedido}/observaciones` );
            req.body.observacion = this.Observacion;
            if ( EnviarAPlataforma )
                req.body.enviar_a_plataforma = 'S';
            if ( await req.post() )
            {
                this.Json = req.data;
                return this.set();
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
}